export const statusFilterOptions = [
  { label: "All Statuses", value: "" },
  { label: "In Progress", value: "IN_PROGRESS" },
  { label: "Pending", value: "PENDING" },
  { label: "Cancelled", value: "CANCELLED" },
  { label: "Expired", value: "EXPIRED" },
  { label: "Completed", value: "COMPLETED" },
];
